import Vue from 'vue';
import Moment from 'moment';

// Set default locale
Moment.locale('en');

Vue.moment = Moment;
